/*********************************************************
 *                  Admin users Ctrl
 *
 ********************************************************/
"use strict";

import dayjs from "dayjs";

angular.module("manager")
	.controller("DeviceEditCtrl", [
		"$routeParams", "LeafletService", "$scope", "$location", "Utils", "device", "mode", "companies", "$uibModal", "toastr", "DeviceService",
		function ($routeParams, LeafletService, $scope, $location, Utils, device, mode, companies, $uibModal, toastr, DeviceService) {

		/************************************************************************************************************
			 *  SETUP
			 *************************************************************************************************************/

		var deleteModal;

		$scope.data = {
			device: device.data,
			mode: mode,
			companies: companies.data
		};

		// --- CARTOGRAPHIE ---
		$scope.LeafletService = LeafletService;
		LeafletService.setMapId("map");
		LeafletService.deleteAllMarkers();
		LeafletService.createMarker({
			lat: $scope.data.device.lastConnectionLat,
			lng: $scope.data.device.lastConnectionLong,
			focus: true,
			message: "Appareil " + $scope.data.device.name,
			draggable: false,
			icon: {
				type: "awesomeMarker",
				icon: "mobile",
				prefix: "fa",
				markerColor: "blue"
			}
		});

		LeafletService.setCenter({
			lat: $scope.data.device.lastConnectionLat,
			lng: $scope.data.device.lastConnectionLong,
			zoom: 17
		});
		// --- FIN CARTOGRAPHIE ---


		/**
			 * Ouvrir la modal de suppression d'un device.
			 */
		$scope.openDeleteModal = function (device) {
			$scope.data.entityToDelete = device;
			deleteModal = Utils.openModal($uibModal, "delete.html", $scope);
		};

		$scope.deleteDevice = function (device) {
			DeviceService.deleteDeviceById(device.id)
				.then(() => {
					$location.path("/manager/devices");
				})
				.catch((error) => {
					toastr.error(Utils.makeErrorMessage(error.data, "Impossible de supprimer l'appareil"), "Problème lors de la suppression de l'appareil");
				});
		};

		/************************************************************************************************************
			 *  $scope functions
			 *************************************************************************************************************/

		// Convertion des dates
		$scope.convertDate = function (date) {
			$scope.lastConnectionDateFormatInput = dayjs(date).second(0).millisecond(0).subtract(2, "hours").toDate();
		};


		$scope.post = function () {

			if ($scope.data.mode === "new") {

				DeviceService.addDevice($scope.data.device).then(() => {
					toastr.success("", "Appareil créé");
					$location.path("/manager/devices");
				}).catch(function (data) {
					var errorMessage = "Problème lors de la création de l'appareil. ";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
			} else if ($scope.data.mode === "edit") {
				DeviceService.editDevice($routeParams.id, $scope.data.device).then((response) => {
					const data = response.data;
					toastr.success("", "L'appareil " + data.name + " a été mis à jour");
					$scope.data.device = data;
				}).catch(function (data) {
					var errorMessage = "Problème lors de la mise à jour de l'appareil. ";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
			}
		};


	}]
	)
;